var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_83_119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.4,
    cy: 21.7999,
    r: 16.7999,
    fill: "#6A4029"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4001 5C26.1216 5 18.6001 12.5215 18.6001 21.8C18.6001 31.0785 26.1216 38.6 35.4001 38.6C44.6786 38.6 52.2001 31.0785 52.2001 21.8C52.2001 12.5215 44.6786 5 35.4001 5ZM42.2339 18.762C42.2409 18.9055 42.2426 19.049 42.2426 19.189C42.2426 23.564 38.9159 28.6058 32.8294 28.6058C31.0309 28.6087 29.2698 28.0922 27.7578 27.1183C28.0151 27.1498 28.2793 27.162 28.5471 27.162C30.0976 27.162 31.5239 26.6353 32.6561 25.7463C31.9661 25.7327 31.2975 25.5042 30.7435 25.0927C30.1896 24.6811 29.7778 24.107 29.5656 23.4503C30.0611 23.5445 30.5716 23.5247 31.0583 23.3925C30.3094 23.2411 29.6359 22.8353 29.1521 22.2439C28.6682 21.6526 28.4038 20.9121 28.4036 20.148V20.1078C28.8498 20.3545 29.3608 20.505 29.9033 20.5225C29.2012 20.0551 28.7042 19.3372 28.5139 18.5155C28.3236 17.6938 28.4544 16.8304 28.8796 16.102C29.7108 17.124 30.7473 17.9601 31.9221 18.556C33.0969 19.152 34.3837 19.4947 35.6994 19.5618C35.5321 18.8518 35.6041 18.1065 35.9041 17.4416C36.2042 16.7768 36.7154 16.2297 37.3585 15.8855C38.0015 15.5412 38.7403 15.419 39.4599 15.5379C40.1796 15.6568 40.8397 16.0102 41.3379 16.543C42.0784 16.3965 42.7886 16.1248 43.4379 15.7398C43.191 16.5065 42.6743 17.1576 41.9836 17.572C42.6396 17.493 43.2801 17.3166 43.8841 17.0488C43.4405 17.7136 42.8816 18.2938 42.2339 18.762Z",
    fill: "#FFBA33"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_83_119",
    x: 0.600098,
    y: 0,
    width: 69.6001,
    height: 69.5999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0658854 0 0 0 0 0.0730469 0 0 0 0 0.1375 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_83_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_83_119",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.3486734005e5dc3b9876ba7f9c4f01b7.svg";
export { ForwardRef as ReactComponent };